// 22.01.19 - Defines a genric getRequest which is used by the Sagas.
import Axios, { AxiosResponse } from "axios";

// This interface describes the structure of the API response
export interface IServerResponse<T> {
  message: string;
  success: boolean;
  count?: number;
  data?: T;
}

// This function takes a list of path segments like ["/UserDetails/GetUserDetailsByUserNameOrId/", "ins3@gmail.com"] and performs a
// get request to the API by combining them to "/UserDetails/GetUserDetailsByUserNameOrId/ins3@gmail.com"
// it also catches any exceptions and returns a message in the same format as the server response instead
export async function getRequest<T>(paths: string[]): Promise<IServerResponse<T>> {
  try {
    // const response: AxiosResponse<IServerResponse<T>> = await Axios.get(paths.join("/"));
    const response: AxiosResponse<IServerResponse<T>> = await Axios.get(paths.join(""));
    return response.data;
  } catch (e) {
    return {
      message: e.toString(),
      success: false
    };
  }
}

export function getRequestSync<T>(paths: string[]) {
  try {
    return Axios.get(paths.join(""))
      .then(
        (response: any) => {
          return response.data;
        },
        (e: any) => {
          return {
            message: e.toString(),
            success: false
          };
        }
      );
    //return response.data;
  } catch (e: any) {
    return {
      message: e.toString(),
      success: false
    };
  }
}